import 'core-js/modules/es.object.assign.js';
import { jsx } from 'react/jsx-runtime';
import { useIsMobile, useUtility } from '@hub-la/design-system';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { useHistory } from 'react-router-dom';
import { getGroupUrl } from '../utils/routes.js';

const BackButton = props => {
  const {
    groupId
  } = props;
  const backLink = getGroupUrl(groupId);
  const isMobile = useIsMobile();
  const {
    palette
  } = useUtility();
  const history = useHistory();
  const handleBack = () => {
    history.goBack();
  };
  return jsx("a", Object.assign({
    href: groupId ? backLink : undefined,
    onClick: handleBack,
    style: {
      height: '21px',
      cursor: 'pointer'
    },
    "data-testid": "back-button"
  }, {
    children: isMobile ? jsx(ArrowBackIosIcon, {
      sx: {
        color: palette('onBackground')
      }
    }) : jsx(ArrowBackIcon, {
      sx: {
        color: palette('onBackground')
      }
    })
  }));
};

export { BackButton };
